import { apiClient } from './api/apiClient';
import {
  EmergencyReport,
  CreateEmergencyReport,
  UpdateEmergencyReportStatus,
  EmergencyReportFilter,
  PagedResponse,
  ApiResponse,
} from '../types';

class EmergencyReportService {
  /**
   * Ottieni lista segnalazioni con filtri e paginazione
   */
  async getEmergencyReports(filter?: EmergencyReportFilter): Promise<PagedResponse<EmergencyReport>> {
    const params = new URLSearchParams();

    if (filter) {
      if (filter.page) params.append('page', filter.page.toString());
      if (filter.pageSize) params.append('pageSize', filter.pageSize.toString());
      if (filter.siteId) params.append('siteId', filter.siteId.toString());
      if (filter.type !== undefined) params.append('type', filter.type.toString());
      if (filter.status !== undefined) params.append('status', filter.status.toString());
      if (filter.priority !== undefined) params.append('priority', filter.priority.toString());
      if (filter.reportedByUserId) params.append('reportedByUserId', filter.reportedByUserId.toString());
      if (filter.fromDate) params.append('fromDate', filter.fromDate);
      if (filter.toDate) params.append('toDate', filter.toDate);
    }

    return await apiClient.get<PagedResponse<EmergencyReport>>(
      `/emergencyreports?${params.toString()}`
    );
  }

  /**
   * Ottieni dettagli segnalazione per ID
   */
  async getEmergencyReportById(id: number): Promise<EmergencyReport> {
    const response = await apiClient.get<ApiResponse<EmergencyReport>>(
      `/emergencyreports/${id}`
    );

    if (response.success && response.data) {
      return response.data;
    }

    throw new Error(response.message || 'Segnalazione non trovata');
  }

  /**
   * Crea nuova segnalazione
   */
  async createEmergencyReport(data: CreateEmergencyReport): Promise<EmergencyReport> {
    const response = await apiClient.post<ApiResponse<EmergencyReport>>(
      '/emergencyreports',
      data
    );

    if (response.success && response.data) {
      return response.data;
    }

    throw new Error(response.message || 'Errore nella creazione della segnalazione');
  }

  /**
   * Aggiorna stato segnalazione (manager/owner)
   */
  async updateStatus(id: number, data: UpdateEmergencyReportStatus): Promise<EmergencyReport> {
    const response = await apiClient.put<ApiResponse<EmergencyReport>>(
      `/emergencyreports/${id}/status`,
      data
    );

    if (response.success && response.data) {
      return response.data;
    }

    throw new Error(response.message || 'Errore nell\'aggiornamento dello stato');
  }

  /**
   * Elimina segnalazione
   */
  async deleteEmergencyReport(id: number): Promise<void> {
    await apiClient.delete(`/emergencyreports/${id}`);
  }
}

// Export singleton instance
export const emergencyReportService = new EmergencyReportService();
